module.exports = __webpack_public_path__ + "img/illustrator.2558a968.svg";